import { useHistory, withRouter } from "react-router-dom"
import React, { useEffect } from "react";
import { logEvent } from "firebase/analytics";

const logCurrentPage = (firebase) => {
  if (firebase.analytics) {
    logEvent(firebase.analytics, 'screen_view', {
      screen_name: window.location.pathname,
      screen_class: window.location.pathname
    });
  }
};
  
const AnalyticsComponent = (props) => {
    const firebase = props.firebase;
    const history = useHistory();
    useEffect(() => {
        logCurrentPage(firebase); // log the first page visit
        history.listen(() => {
            logCurrentPage(firebase);
        });
    }, [history]);
    return (<div></div>);
};

export default withRouter(AnalyticsComponent);